import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";

import NotationTableCell from "@components/evaluation/NotationTableCell";
import Button from "@components/tailwindComponents/Button";
import BlackTooltip from "@components/tooltip/BlackTooltip";

export default function CriteriaItem(props) {
  const { surveySubject, openModalUpsertObjective, readOnly, goToDetail } =
    props;

  return (
    <tr className="arh-border arh-border-x-0 arh-border-t-0 arh-border-solid arh-border-borderTable">
      <td className="arh-py-[0.688rem] arh-pl-4 arh-pr-4">
        <BlackTooltip
          title={surveySubject.name}
          placement="top-start"
        >
          <div className="arh-line-clamp-2 arh-max-w-fit arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor">
            {surveySubject.name}
          </div>
        </BlackTooltip>
      </td>
      {/* Status comme dans items status.js */}
      <NotationTableCell
        evaluationFormat={surveySubject.surveyFormat}
        note={surveySubject.surveySubjectNotation?.note}
        onClick={goToDetail}
      />
      <td className="arh-py-[0.688rem] arh-pl-4 arh-pr-4">
        <BlackTooltip
          title={
            surveySubject.surveySubjectNotation?.SurveyObjective
              ?.nextObjective || "-"
          }
          placement="top-start"
        >
          <div className="arh-flex arh-items-center arh-justify-center">
            <span className="arh-line-clamp-3 arh-w-full arh-max-w-fit arh-whitespace-break-spaces arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor ">
              {surveySubject.surveySubjectNotation?.SurveyObjective
                ?.nextObjective || "-"}
            </span>
          </div>
        </BlackTooltip>
      </td>
      <td className="arh-py-[0.688rem] arh-pl-4 arh-pr-4  ">
        <BlackTooltip
          title={
            surveySubject.surveySubjectNotation?.SurveyObjective
              ?.availableMeans || "-"
          }
          placement="top-start"
        >
          <div className="arh-flex arh-items-center arh-justify-center">
            <span className="arh-line-clamp-3 arh-w-full arh-max-w-fit arh-whitespace-break-spaces arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor ">
              {surveySubject.surveySubjectNotation?.SurveyObjective
                ?.availableMeans || "-"}
            </span>
          </div>
        </BlackTooltip>
      </td>
      <td className="arh-py-[0.688rem] arh-pl-4 arh-pr-4  ">
        <BlackTooltip
          title={
            surveySubject.surveySubjectNotation?.SurveyObjective
              ?.mainObjective || "-"
          }
          placement="top-start"
        >
          <div className="arh-flex arh-items-center arh-justify-center">
            <span className="arh-line-clamp-3 arh-w-full arh-max-w-fit arh-whitespace-break-spaces arh-text-start arh-font-poppins arh-text-xs arh-font-semibold arh-text-darkColor ">
              {surveySubject.surveySubjectNotation?.SurveyObjective
                ?.mainObjective || "-"}
            </span>
          </div>
        </BlackTooltip>
      </td>

      <td className="arh-px-4">
        <div className="arh-mx-4 arh-my-[0.3rem] arh-flex arh-items-center arh-justify-end">
          <CriteriaItemButton
            readOnly={readOnly}
            objective={surveySubject.surveySubjectNotation?.SurveyObjective}
            onClick={() => openModalUpsertObjective(surveySubject)}
          />
        </div>
      </td>
    </tr>
  );
}

function CriteriaItemButton(props) {
  const { readOnly, objective } = props;
  const { t: translator } = useTranslation("assesment.frequency");

  const hasObjective = useMemo(() => {
    if (!objective) {
      return false;
    }

    return (
      objective.nextObjective ||
      objective.availableMeans ||
      objective.mainObjective
    );
  }, [objective]);

  if (readOnly) {
    if (!hasObjective) {
      return null;
    }

    return (
      <Button
        variant="green-outlined"
        onClick={props.onClick}
      >
        {translator("Visualiser")}
      </Button>
    );
  }

  // If not readOnly from here
  if (hasObjective) {
    return (
      <Button
        variant="green-outlined"
        onClick={props.onClick}
      >
        {translator("Modifier")}
      </Button>
    );
  }

  return (
    <Button
      variant="outlined"
      onClick={props.onClick}
    >
      {translator("Ajouter")}
    </Button>
  );
}
